<template>
  <div class="pagination-container">
    <div 
      v-if="prevSection" 
      class="nav-card prev" 
      @click="$emit('navigate', prevSection.id)"
    >
      <span class="label">Anterior</span>
      <span class="title">« {{ prevSection.title }}</span>
    </div>
    <div v-else class="spacer"></div>

    <div 
      v-if="nextSection" 
      class="nav-card next" 
      @click="$emit('navigate', nextSection.id)"
    >
      <span class="label">Siguiente</span>
      <span class="title">{{ nextSection.title }} »</span>
    </div>
    <div v-else class="spacer"></div>
  </div>
</template>

<script>
export default {
  props: {
    currentView: String,
    sections: Array // Ejemplo: [{id: 'Introduction', title: 'Introducción'}, ...]
  },
  computed: {
    currentIndex() {
      return this.sections.findIndex(s => s.id === this.currentView);
    },
    prevSection() {
      return this.currentIndex > 0 ? this.sections[this.currentIndex - 1] : null;
    },
    nextSection() {
      return this.currentIndex < this.sections.length - 1 ? this.sections[this.currentIndex + 1] : null;
    }
  }
}
</script>

<style scoped>
.pagination-container {
  display: flex;
  gap: 20px;
  margin-top: 50px;
  padding-top: 30px;
  border-top: 1px solid var(--border-color);
}

.nav-card {
  flex: 1;
  padding: 20px;
  border: 1px solid var(--border-color);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  background: var(--bg-color);
}

.nav-card:hover {
  border-color: var(--primary-color);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.prev { align-items: flex-start; text-align: left; }
.next { align-items: flex-end; text-align: right; }

.label {
  font-size: 0.85rem;
  color: #64748b;
  margin-bottom: 4px;
}

.title {
  font-weight: bold;
  color: var(--primary-color);
  font-size: 1.1rem;
}

.spacer { flex: 1; }

/* Responsive */
@media (max-width: 600px) {
  .pagination-container { flex-direction: column; }
}
</style>